import messageResource from '../../../messageResource'
import * as EntitiesActions from '../../../entities/actions'

export function needMoreEntities(showEditor, entitiesLevelSelected, entitiesLoading, entitiesLoaded) {
    return showEditor && entitiesLevelSelected && !entitiesLoading && !entitiesLoaded
}

export function hasConcurrentlyRemovedEntities(data) {
    const removedEntitiesIds = data['additionalResultData']['map']['concurrentlyRemovedEntities']
    return removedEntitiesIds && (
        (removedEntitiesIds.customers && removedEntitiesIds.customers.length > 0)
        || (removedEntitiesIds.projects && removedEntitiesIds.projects.length > 0)
        || (removedEntitiesIds.tasks && removedEntitiesIds.tasks.length > 0)
    )
}

export const handleConcurrentlyRemovedEntitiesAction = ({
    getEditingLevel,
    hierarchyAssignmentsEditorActions,
}) => (data, assignAll = false) => (dispatch, getState) => {

    const state = getState()
    const {customerId, projectId} = getEditingLevel(state)
    const removedEntitiesIds = data['additionalResultData']['map']['concurrentlyRemovedEntities']

    if (removedEntitiesIds) {
        if (removedEntitiesIds.customers && removedEntitiesIds.customers.length > 0) {
            const msgKey = projectId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.customer_of_task'
                                                            : customerId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.customer_of_project'
                                                                                                : 'userlist.ha_editor.concurrently_deleted_error.customer'
            alert(messageResource.getMessage(msgKey))
            if (customerId !== null) {
                dispatch(hierarchyAssignmentsEditorActions.deselectCustomer(customerId))
            }
            dispatch(EntitiesActions.removeCustomers(removedEntitiesIds.customers))
        } else if (removedEntitiesIds.projects && removedEntitiesIds.projects.length > 0) {
            const msgKey = projectId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.project_of_task'
                                                            : 'userlist.ha_editor.concurrently_deleted_error.project'
            alert(messageResource.getMessage(msgKey))
            if (projectId !== null) {
                dispatch(hierarchyAssignmentsEditorActions.deselectProject(projectId))
            }
            dispatch(EntitiesActions.removeProjects(removedEntitiesIds.projects))
        } else if (removedEntitiesIds.tasks && removedEntitiesIds.tasks.length > 0) {
            alert(messageResource.getMessage('userlist.ha_editor.concurrently_deleted_error.task'))
            dispatch(EntitiesActions.removeTasks(removedEntitiesIds.tasks))
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsEditor/utils.js